import { getData } from "./apiService.js";
export async function getAll(params = {}) {
    let response = await getData("townships/get", params);
    return response.data;
  }